module.exports = __webpack_public_path__ + "img/p5.867dfd2d.png";